export { CollectionInfoSidebar } from "./CollectionInfoSidebar";
